import React, {useCallback, useEffect, useRef, useState} from 'react';
import {WorkshopSceneState} from "../../models/WorkshopSceneState";
import './WorkshopAdminPage.scss';
import {Store} from "../../models/Store";
import {useParams} from "react-router";
import {Link} from "react-router-dom";

export const WsGroupsEdit = () => {

    const {id} = useParams();

    const [groupId, setGroupId] = useState(id);
    const [videoId, setVideoId] = useState<string>('');
    const [scene, setScene] = useState<WorkshopSceneState>(WorkshopSceneState.Wait);
    const [isLoaded, setLoaded] = useState<boolean>(false);

    const groupIdInputRef = useRef<HTMLInputElement>(null);
    const videoIdInputRef = useRef<HTMLInputElement>(null);
    const loadButtonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
    }, []);

    const onLoadButtonClick = useCallback(() => {
        (async () => {
            const v = groupIdInputRef.current?.value;
            if (!v) return;

            setLoaded(true);

            const data = await Store.hoge(v);

            // videoid
            if (data?.videoId) setVideoId(data.videoId);

            // scene
            if (data?.scene) setScene(data.scene);
            else setScene(WorkshopSceneState.Wait);
        })();
    }, []);

    const onRadioChange = useCallback(((e) => {
        setScene(e.target.value);
    }), []);

    useEffect(()=>{
        if(groupId) {
            onLoadButtonClick();
            // if(groupIdInputRef.current){
            //     groupIdInputRef.current.disabled = true;
            // }
            // if(loadButtonRef.current){
            //     loadButtonRef.current.disabled=true;
            // }
        }
    },[groupId,onLoadButtonClick]);

    return (<div className={'workshop-admin'}>
        <h6>ひかりの実スマイルアトリエ > 管理画面 > ワークショップ設定 > グループ一覧</h6>
        <h1>グループ作成・変更</h1>

        <Link to={'/admin/ws/groups/'}>&lt;&nbsp;戻る</Link>

        <hr/>

        <h2>グループID</h2>
        <div><input type="text" name="" id="group-id-input" defaultValue={groupId} ref={groupIdInputRef} onChange={(e) => {
            setGroupId(e.target.value);
        }}/></div>

        <div>
            <button onClick={onLoadButtonClick} ref={loadButtonRef}>読み込み</button>
        </div>

        <hr/>

        <h2>YoutubeビデオID</h2>
        <div><input type="text" name="" id="youtube-video-id-input" value={videoId} ref={videoIdInputRef} onChange={(e) => {
            setVideoId(e.target.value);
        }} disabled={!isLoaded}/></div>

        <div>
            <button onClick={() => {
                Store.firestore_ws_updateVideoId(groupId, videoId);
            }} disabled={!isLoaded}>保存
            </button>
        </div>

        <hr/>

        <h2>ページの状態</h2>
        <div>
            <label><input type="radio" name='workshopstate' value={WorkshopSceneState.Wait}
                          checked={scene === WorkshopSceneState.Wait} onChange={onRadioChange}
                          disabled={!isLoaded}/>&nbsp;開始前待機画面</label>
            <label><input type="radio" name='workshopstate' value={WorkshopSceneState.Video}
                          checked={scene === WorkshopSceneState.Video} onChange={onRadioChange}
                          disabled={!isLoaded}/>&nbsp;ビデオ画面</label>
            <label><input type="radio" name='workshopstate' value={WorkshopSceneState.Drawing}
                          checked={scene === WorkshopSceneState.Drawing} onChange={onRadioChange}
                          disabled={!isLoaded}/>&nbsp;お絵かき</label>
        </div>

        <div>
            <button onClick={() => {
                Store.firestore_ws_updateScene(groupId, scene);
            }} disabled={!isLoaded}>保存
            </button>
        </div>

    </div>);
};